import type { Rule } from "../types";
import { makeFiring } from "../util";

const EVIDENCE = "seiler_2010_polarized_80_20";

/**
 * No low-intensity (RPE ≤ 5) endurance session in the last 7 days. Companion
 * to `polarized_ratio_off` — surfaces the immediate gap rather than the
 * cumulative one. Encourages an aerobic-base session before the next high
 * intensity block.
 */
const ENDURANCE_RX = /run|cycling|bike|swim|row|ski|trail|gravel|tt/;

export const noZ2In7Days: Rule = {
  id: "no_z2_session_7d",
  domain: "health.training",
  topics: ["z2", "polarized_training"],
  evidence_refs: [EVIDENCE],
  title: () => "No Z2 session this week",
  evaluate(ctx) {
    const now = ctx.now.getTime();
    const day = 86_400_000;
    const sevenDay = ctx.sessions.filter(
      (s) =>
        ENDURANCE_RX.test(s.sport_id) &&
        now - new Date(s.end_ts).getTime() <= 7 * day,
    );
    if (sevenDay.length === 0) return null;
    const hasLow = sevenDay.some((s) => (s.rpe ?? 5) <= 5);
    if (hasLow) return null;
    const totalDuration = sevenDay.reduce((s, x) => s + x.duration_min, 0);
    return makeFiring({
      rule_id: "no_z2_session_7d",
      now: ctx.now,
      tz: ctx.tz,
      severity: "neutral",
      message: `${sevenDay.length} endurance session${sevenDay.length === 1 ? "" : "s"} this week (${Math.round(totalDuration)}min) — none at Z1-Z2. Add an easy session before the next hard block.`,
      evidence_refs: [EVIDENCE],
      factors: [
        {
          name: "z2_count_7d",
          value: 0,
          contribution: "add easy session",
          evidence_ref: EVIDENCE,
        },
      ],
      target_surface: "health.training",
    });
  },
};
